<template>
  <div id="app-pc">
    <div class="logout">
      <el-date-picker
        v-if="
          $route.path == '/pad/carRelease' || $route.path == '/pad/dormManage'
        "
        v-model="releaseDate"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        @change="changeReleaseDate"
        placeholder="请选择时间"
        :clearable="false"
        style="width: 150px; margin-right: 100px"
      />
      <div class="out_con" @click="logout">
        <img src="@/assets/visitor/out.png" alt="" /> 退出登录
      </div>
    </div>
    <div class="menu-container">
      <div class="logo_content">
        <img class="logo" src="@/assets/visitor/logo.png" alt="" />
      </div>
      <div v-for="(menu, index) in menus" :key="index">
        <a
          v-if="menu.show"
          :class="{ active: $route.path == menu.path }"
          href="javascript:;"
          class="menu-item"
          @click="$router.replace(menu.path)"
        >
          <img
            class="img"
            :src="$route.path == menu.path ? menu.activeImg : menu.img"
            alt=""
          />
          {{ menu.label }}
        </a>
      </div>
    </div>
    <div class="pages">
      <router-view class="page-container" ref="pageContainer" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
export default {
  name: "pc",
  data() {
    return {
      menus: [
        // {
        //   label: "访客管理",
        //   path: "/pad/visitor",
        //   show: true,
        //   img: require("@/assets/visitor/fangke.png"),
        //   activeImg: require("@/assets/visitor/activeFangke.png")
        // },
        // {
        //   label: "车辆放行",
        //   path: "/pad/carRelease",
        //   show: true,
        //   img: require("@/assets/visitor/fangxing.png"),
        //   activeImg: require("@/assets/visitor/activeFangxing.png")
        // },
        // {
        //   label: "物品及其他放行",
        //   path: "/pad/dormManage",
        //   show: true,
        //   img: require("@/assets/visitor/wupin.png"),
        //   activeImg: require("@/assets/visitor/activeWupin.png")
        // }
      ],
      releaseDate: moment(new Date()).format("YYYY-MM-DD")
    };
  },
  mounted() {
    // this.queryRole(sessionStorage.getItem("usernamePad"));
    if (this.$route.path == "/pad/dormManage") {
      this.menus = [
        {
          label: "物品及其他放行",
          path: "/pad/dormManage",
          show: true,
          img: require("@/assets/visitor/wupin.png"),
          activeImg: require("@/assets/visitor/activeWupin.png")
        },
        {
          label: "车辆放行",
          path: "/pad/carRelease",
          show: true,
          img: require("@/assets/visitor/fangxing.png"),
          activeImg: require("@/assets/visitor/activeFangxing.png")
        }
      ];
    } else {
      this.menus = [
        {
          label: "车辆放行",
          path: "/pad/carRelease",
          show: true,
          img: require("@/assets/visitor/fangxing.png"),
          activeImg: require("@/assets/visitor/activeFangxing.png")
        },
        {
          label: "物品及其他放行",
          path: "/pad/dormManage",
          show: true,
          img: require("@/assets/visitor/wupin.png"),
          activeImg: require("@/assets/visitor/activeWupin.png")
        }
      ];
    }
  },
  methods: {
    // 退出登录
    logout() {
      sessionStorage.setItem("usernamePad", "");
      this.$router.replace({
        path: "/visitorPadLogin"
      });
    },
    // 改变放行日期
    changeReleaseDate() {
      this.$refs.pageContainer.releaseDate = this.releaseDate;
      this.$refs.pageContainer.changeReleaseDate();
    },
    // 查询角色权限
    queryRole(username) {
      api.queryRoleApi({ username }).then(res => {
        if (res.code == 200) {
          this.dataType = res.data.map(item => item.dataType);
          console.log(this.dataType);
          if (this.dataType.includes(1) || this.dataType.includes(2)) {
            this.menus = [
              {
                label: "物品及其他放行",
                path: "/pad/dormManage",
                show: true,
                img: require("@/assets/visitor/wupin.png"),
                activeImg: require("@/assets/visitor/activeWupin.png")
              },
              {
                label: "车辆放行",
                path: "/pad/carRelease",
                show: true,
                img: require("@/assets/visitor/fangxing.png"),
                activeImg: require("@/assets/visitor/activeFangxing.png")
              }
            ];
          } else {
            this.menus = [
              {
                label: "车辆放行",
                path: "/pad/carRelease",
                show: true,
                img: require("@/assets/visitor/fangxing.png"),
                activeImg: require("@/assets/visitor/activeFangxing.png")
              },
              {
                label: "物品及其他放行",
                path: "/pad/dormManage",
                show: true,
                img: require("@/assets/visitor/wupin.png"),
                activeImg: require("@/assets/visitor/activeWupin.png")
              }
            ];
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#app-pc {
  background: #f6f6f6;
  display: flex;
  position: relative;
  .logout {
    position: absolute;
    // right: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 10px;
    color: #7d7d7d;
    font-weight: 600;
    cursor: pointer;
    background-color: #fff;
    width: 100%;
    height: 34px;
    padding-right: 20px;
    .out_con {
      position: absolute;
      display: flex;
      align-items: center;
      z-index: 9;
    }
    img {
      display: block;
      width: 11px;
      height: 11px;
      margin-right: 5px;
    }
    ::v-deep {
      .el-input__inner {
        border-color: #388654;
        color: #388654;
      }

      .el-input__inner::placeholder {
        color: #388654;
      }
      .el-input__icon {
        color: #388654;
      }
    }
  }
}
.menu-container {
  position: relative;
  z-index: 9;
  background: #008755;
  box-shadow: 1px 0px 0px 0px rgba(32, 41, 74, 0.06);
  border-radius: 0 20px 0 0;
  padding-right: 10px;
  .logo_content {
    .logo {
      width: 102px;
      height: 20px;
      margin-top: 40px;
      margin-bottom: 50px;
      padding: 0 18px;
    }
  }
  .menu-item {
    display: inline-block;
    line-height: 30px;
    font-size: 12px;
    text-decoration: none;
    font-weight: 500;
    color: #fff;
    padding: 2px 10px 2px 10px;
    border-radius: 0 18px 18px 0;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    .img {
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
    &.active {
      color: #008755;
      font-weight: bold;
      background-color: #fff;
    }
  }
}

.pages {
  // padding: 10px 9px;
  margin-top: 34px;
  width: calc(100vw - 150px);
}

.page-container {
  padding: 8px 8px 0 8px;
  // background: #fff;
  // border-radius: 9px;
}
</style>
